/** Import react/libraries section **/
import React from 'react';

import withStyles from '@mui/styles/withStyles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** Import styles section **/
import './MenuStyles.scss';

/** Import helpers section **/
import { MenuAccess } from '../../access/AccessControl';

/** Import component section **/
import MenuItem from './MenuItem';

const Accordion = withStyles({
  root: {
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    // backgroundColor: 'rgba(0, 0, 0, .05)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    minHeight: 40,
    height: 40,
    justifyContent: 'flex-start !important',
    padding: '0 10px 0 0',
    margin: '0',
    '&$expanded': {
      minHeight: 40
    }
  },
  content: {
    padding: '0 10px 0 0',
    '&$expanded': {
      margin: '0'
    }
  },
  expandIcon: {
    padding: '5px',
    color: 'rgba(255, 255, 255, .97)',
    marginRight: '-4px',
    transform: 'rotate(-90deg)',
    '&$expanded': {
      transform: 'rotate(0deg)'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: ' 0 0 0 10px !important',
    display: 'flex',
    flexDirection: 'column'
  }
}))(MuiAccordionDetails);

const MenuAccordion = ({ data, expanded, onChange }) => {
  return (
    <Accordion expanded={expanded} onChange={onChange(data?.id)}>
      <AccordionSummary
        id={data?.id}
        expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
        aria-controls={'menu-item-content-' + data?.id}
      >
        <MenuItem item={data} />
      </AccordionSummary>
      <AccordionDetails>
        <>
          {data?.items.map((subitem, sub_index) => (
            <MenuAccess key={sub_index} permissionsRequest={subitem?.id}>
              <div className="mainmenu_item">
                <MenuItem item={subitem} />
              </div>
            </MenuAccess>
          ))}
        </>
      </AccordionDetails>
    </Accordion>
  );
};

export const MenuView = ({ items, expanded, onChange }) => {
  return (
    <div className="mainmenu">
      {items?.map((item, index) => (
        <MenuAccess key={index} permissionsRequest={item?.id}>
          {item?.items && item?.items.length > 0 ? (
            <MenuAccordion
              data={item}
              expanded={expanded === item?.id}
              onChange={onChange}
            />
          ) : (
            <div className="mainmenu_item">
              <MenuItem item={item} />
            </div>
          )}
        </MenuAccess>
      ))}
    </div>
  );
};

export default MenuView;
